module.exports = __webpack_public_path__ + "d99c1459aa62f7553ea2d6f066a95c49.jpg";